import omit from 'lodash/omit'
import React from 'react'
import * as styles from './style'

export interface Props extends React.ComponentPropsWithoutRef<'span'> {
  bytes: number | undefined | null
  fallback?: string
}

export function SizeInBytes(props: Props): JSX.Element | null {
  const formatted = typeof props.bytes === 'number' ? formatBytes(props.bytes) : undefined
  if (!formatted) {
    return null
  }

  return (
    <span className={`${styles.root} ${props.className}`} {...omit(props, 'bytes', 'className')}>
      {formatted}
    </span>
  )
}

// https://stackoverflow.com/a/18650828
function formatBytes(bytes: number, decimals = 2): string {
  if (!+bytes) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}
